import { dayjs, Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import React from 'react'

export type OutdatedRule = {
  amount: number
  unit: dayjs.UnitType
  getTooltip?: (formattedDate: string) => React.ReactNode
  asterisk?: boolean
  hideValue?: boolean
}

export type RuleType = keyof typeof rules

export const rules = {
  '12-hours': {
    amount: 12,
    asterisk: true,
    getTooltip: formattedDate => (
      <span>
        {Translate({
          messageKey: 'data_from_date',
          params: { date: formattedDate },
        })}
        .{' '}
        {Translate({
          messageKey: 'no_data_between_hours',
          params: { from: 12, to: 48 },
        })}
      </span>
    ),
    unit: 'hours',
  } as OutdatedRule,

  '24-hours': {
    amount: 24,
    asterisk: true,
    unit: 'hours',
  } as OutdatedRule,

  '48-hours': {
    amount: 48,
    asterisk: true,
    getTooltip: () =>
      Translate({
        messageKey: 'no_data_after_hours',
        params: { hours: 48 },
      }),
    hideValue: true,
    unit: 'hours',
  } as OutdatedRule,

  '60-days': {
    amount: 60,
    asterisk: false,
    hideValue: true,
    unit: 'days',
  } as OutdatedRule,

  '7-days': {
    amount: 7,
    asterisk: true,
    hideValue: true,
    unit: 'days',
  } as OutdatedRule,
}

type VerifyIfOutdatedParams = { rules: OutdatedRule[]; timestamp?: string }

export const verifyIfOutdated = ({ rules, timestamp }: VerifyIfOutdatedParams) => {
  const reversed = [...rules].reverse()

  const date = Moment(timestamp)
  const now = Moment()

  return reversed.find(rule => now.diff(date, rule.unit) >= rule.amount)
}

export const outdatedRules = {
  batch: [rules['24-hours'], rules['7-days']],
  monitoring: [rules['12-hours'], rules['48-hours']],
  productionAverage: [{ ...rules['7-days'], hideValue: false }, rules['60-days']],
}
